import { Pane, Heading, Paragraph, Card, Text } from 'evergreen-ui';
import HeroBanner from '../commons/HeroBanner';

const CosaFacciamoPage = () => {
  return (
    <Pane className="public-page-container">
      <HeroBanner 
        title="Un percorso, non una soluzione" 
        bgImage="/cosafacciamo (2).png" // Inserisci qui l'immagine corretta
      />
      
      <Pane maxWidth={1000} marginX="auto" paddingY={60} paddingX={20} textAlign="center">
        <Paragraph size={600} marginBottom={40} color="muted">
          Lavoriamo ogni giorno per costruire percorsi educativi personalizzati.
        </Paragraph>
        
          <Pane display="flex" flexDirection="column" gap={32}>
          {/* Sezione 1 */}
          <Card backgroundColor="tint2" padding={32} borderRadius={8} elevation={1} hoverElevation={3} cursor="default">
            <Heading size={700} marginBottom={16}>Accoglienza educativa</Heading>
            <Text size={500} display="block" marginBottom={8}>Un ambiente sicuro</Text>
            <Text size={500} display="block" color="muted">Una quotidianità condivisa</Text>
          </Card>

          {/* Sezione 2 */}
          <Card backgroundColor="tint1" padding={32} borderRadius={8} elevation={1} hoverElevation={3} cursor="default">
            <Heading size={700} marginBottom={16}>Percorsi personalizzati</Heading>
            <Text size={500} display="block" marginBottom={8}>Ogni ragazzo è diverso</Text>
            <Text size={500} display="block" color="muted">Ogni percorso lo è altrettanto</Text>
          </Card>

          {/* Sezione 3 */}
          <Card backgroundColor="tint2" padding={32} borderRadius={8} elevation={1} hoverElevation={3} cursor="default">
            <Heading size={700} marginBottom={16}>Lavoro con le famiglie</Heading>
            <Text size={500} display="block" marginBottom={8}>Costruiamo legami</Text>
            <Text size={500} display="block" color="muted">Non li sostituiamo</Text>
          </Card>
        </Pane>
      </Pane>
    </Pane>
  );
}

export default CosaFacciamoPage;